import { Spinner } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const ModulesSpinner = () => (
  <S.Wrapper>
    <Spinner size="exa" color="green" />
  </S.Wrapper>
)

export default ModulesSpinner
